import debounce from 'lodash/debounce'
import { action, computed, makeObservable, observable } from 'mobx'
import { computedRouteParam } from '@stores/computedRouteParam'
import { computedFn } from 'mobx-utils'

import { SortDirection } from '@avantstay/data-grid'

import { ExtendedColumnKey } from '@new/__global/components/FiltersFramework'

import { BaseStore, SortOrderProps } from '../__types'
import { fastTapeChartPaths } from '../config/contants'

export class NavigationStore {
  constructor(private getApiStore: () => BaseStore['apiStore']) {
    makeObservable(this, {
      pageSize: observable,
      resetPage: action.bound,
      searchTerms: computed,
      page: computed,
      pagesCount: computed,
      setSortOrder: action.bound,
      setPage: action.bound,
      setPageSize: action.bound,
    })
  }

  get tapeChartApiStore() {
    return this.getApiStore()
  }

  pageSize = 30

  private _searchTerms = computedRouteParam<string>('t', { patterns: fastTapeChartPaths })

  private _sortBy = computedRouteParam<ExtendedColumnKey | undefined>('sortBy', {
    patterns: fastTapeChartPaths,
  })

  private _sortOrder = computedRouteParam<SortDirection>('sortOrder', {
    patterns: fastTapeChartPaths,
  })

  private _page = computedRouteParam.int('page', { patterns: fastTapeChartPaths, defaultValue: 1 })

  resetPage() {
    if (this.page > 1) {
      this.setPage(1)
    }
  }

  sortBy = computedFn(() => {
    return this._sortBy.get()
  })

  sortOrder = computedFn(() => {
    return this._sortOrder.get()
  })

  get searchTerms() {
    return this._searchTerms.get()
  }

  get page() {
    return this._page.get()
  }

  get pagesCount() {
    return this.tapeChartApiStore.totalListings
      ? Math.ceil(this.tapeChartApiStore.totalListings / this.pageSize)
      : 0
  }

  setSortOrder({ sortOrder, sortByKey }: SortOrderProps) {
    const newSortByKey = sortOrder || sortOrder === SortDirection.None ? sortByKey : undefined

    this._sortBy.push(newSortByKey as ExtendedColumnKey)
    this._sortOrder.push(sortOrder)
  }

  setPage(page: number) {
    return this._page.push(page)
  }

  setPageSize(pageSize: number) {
    return (this.pageSize = pageSize)
  }

  setSearchTerms = debounce((v: string) => {
    requestAnimationFrame(() => {
      this._searchTerms.push(v)
    })
  }, 400)
}
